import Vue from 'vue'
import VueRouter from 'vue-router'
import store, { actionNames } from './store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: new URL(process.env.VUE_APP_BASE_URL).pathname,
  routes: [
    {
      path: '/callback',
      name: 'auth-callback',
      component: () => import(/* webpackChunkName: "callback" */ './auth/pages/Callback.vue')
    },
    {
      path: '/activate/:token',
      name: 'activate',
      beforeEnter: async (to, from, next) => {
        await store.dispatch(actionNames.GET_ANONYMOUS_USER)
        next()
      },
      component: () => import(/* webpackChunkName: "callback" */ './auth/pages/Activate.vue')
    },
    {
      path: '/',
      component: () => import(/* webpackChunkName: "dashboard" */ './global/components/Dashboard.vue'),
      beforeEnter: async (to, from, next) => {
        await store.dispatch(actionNames.GET_LOGGED_IN_USER)
        next()
      },
      children: [
        {
          path: '/',
          redirect: '/overview'
        },
        {
          path: '/overview',
          name: 'overview',
          component: () => import(/* webpackChunkName: "overview" */ './overview/Overview.vue')
        },
        {
          path: '/projects',
          name: 'projects',
          component: () => import(/* webpackChunkName: "api-keys" */ './projects/Projects.vue')
        },
        {
          path: '/custom-labels',
          name: 'customLabels',
          component: () => import(/* webpackChunkName: "api-keys" */ './custom-labels/CustomLabels.vue')
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import(/* webpackChunkName: "profile" */ './settings/Settings.vue')
        },
        {
          path: '/sentiment-rules',
          name: 'sentiment-rules',
          component: () => import(/* webpackChunkName: "profile" */ './sentiment-rules/SentimentRules.vue')
        },
        {
          path: '/admin',
          name: 'admin',
          component: () => import(/* webpackChunkName: "profile" */ './admin/Admin.vue'),
          beforeEnter: async (to, from, next) => {
            if (store.getters.isAdmin) {
              next()
            } else {
              await next('/')
            }
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

export default router
